module.exports = __webpack_public_path__ + "img/0.7c472659.svg";